import { createAction } from '@reduxjs/toolkit';
export const REMOVE_CONFERENCE_PARTICIPANT = 'REMOVE_CONFERENCE_PARTICIPANT';
export const removeConferenceParticipantAction = createAction(REMOVE_CONFERENCE_PARTICIPANT);